module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_fds_m.6731cc823b10364b4905e7627efcad2f.png";